module.exports = __webpack_public_path__ + "img/Fiche community manager.72172b46.jpg";